class MapIndexAnimation {

	constructor () {
		this.opt = {
			svg: ".js-map-route-network",
			nameSity: ".js-name-sity",
			cutName: ".js-cut-name",

			group: ".js-group",

			informationSity: ".js-information-sity",

			classOpen: "route-network-maps__block--open"
		};

		this.lang = $("html").attr("lang");

		this.$svg = $(this.opt.svg);

		this.$group = $(this.opt.group);

		this.$informationSity = $(this.opt.informationSity);
	}

	InitSVG () {
		const self = this;

		this.$group.tooltipster({
			contentCloning: true,
			trigger : 'custom' ,
			arrow: false,
			theme: "tooltipster-noir-customized",
			triggerOpen: {
				mouseenter: true,
				click: true,
			},
			interactive: true,
			triggerClose: {
				mouseleave: true,
			},
			side: "right",
			functionBefore () {
				const   $obj = this._$origin,
						$informationSity = this.__Content,
						cutName = $obj.data("text-cut"),
						nameSity = $obj.data(`text-${self.lang}`);

				$informationSity.find(self.opt.nameSity).text(nameSity);
				$informationSity.find(self.opt.cutName).text(cutName);
			},
			functionPosition: function(instance, helper, position){
				position.coord.left -= 30;
				return position;
			}
		});

		this.CheckSVG();
	}

	CheckSVG () {
		const data = global.getHash();

		if (data.type === 'tabs') {
			this.ChangeTypeSVG(data);
		} else if(!data.type) {
			this.OpenFirstSVG();
		}
	}

	ChangeTypeSVG (data) {
		const $obj = $(`${this.opt.svg}[data-type='${data.name}']`);

		this.$svg.removeClass(this.opt.classOpen);

		$obj.addClass(this.opt.classOpen);
	}

	OpenFirstSVG () {
		this.$svg.eq(0).addClass(this.opt.classOpen);
	}
}

let map = new MapIndexAnimation();
map.InitSVG();

$(window).on('hashchange', function(){
	map.CheckSVG();
});



// WEBPACK FOOTER //
// ./frontend/components/route-network-maps/route-network-maps.js